import { render, staticRenderFns } from "./ChatQuotaUsed.vue?vue&type=template&id=891a9e80"
import script from "./ChatQuotaUsed.vue?vue&type=script&lang=js"
export * from "./ChatQuotaUsed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports